<template>
    <b-container fluid>
        <b-row>
            <b-col xl="12" lg="12" sm="12">
                <iq-card>
                    <template  v-slot:headerTitle>
                     <h4 class="card-title">{{ $t('external_sidebar.sales_entry') }}</h4>
                    </template>
                    <template v-slot:body>
                        <b-overlay :show="loading">
                            <b-row v-if="view === false">
                                <b-col class="col-12">
                                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                        <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" >
                                            <b-row>
                                                <b-col lg="4" sm="12">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="category_id"
                                                        >
                                                        <template v-slot:label>
                                                        {{$t('retailerManagement.product_category')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="detailsFormData.category_id"
                                                        id="category_id"
                                                        :options="categoryList"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" sm="12">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="sub_category_id"
                                                        >
                                                        <template v-slot:label>
                                                        {{$t('retailerManagement.product_sub_category')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="detailsFormData.sub_category_id"
                                                        id="sub_category_id"
                                                        :options="subCategoryList"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" sm="12">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="product_id"
                                                        >
                                                        <template v-slot:label>
                                                        {{$t('retailerManagement.product_name')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="detailsFormData.product_id"
                                                        id="product_id"
                                                        :options="productNameList"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" sm="12">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="unit"
                                                        >
                                                        <template v-slot:label>
                                                            {{ $t('retailerManagement.unit') }} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                            type="number"
                                                            id="unit"
                                                            v-model="detailsFormData.unit"
                                                            disabled
                                                        ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" sm="12">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="quantity"
                                                    >
                                                        <template v-slot:label>
                                                        {{ $t('retailerManagement.quantity')}}
                                                        </template>
                                                        <b-form-input
                                                        type="number"
                                                        id="quantity"
                                                        v-model="detailsFormData.quantity"
                                                        ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" sm="12">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="unit_price"
                                                    >
                                                        <template v-slot:label>
                                                        {{ $t('sales_distribution_admin.unit_price')}}
                                                        </template>
                                                        <b-form-input
                                                        type="number"
                                                        id="unit_price"
                                                        v-model="detailsFormData.unit_price"
                                                        disabled
                                                        ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" sm="12">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="total_price"
                                                    >
                                                        <template v-slot:label>
                                                        {{ $t('sales_distribution_admin.total_price')}}
                                                        </template>
                                                        <b-form-input
                                                        type="number"
                                                        id="total_price"
                                                        v-model="detailsFormData.total_price"
                                                        disabled
                                                        ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col lg="4" sm="12">
                                                    <b-button @click.prevent="addItem()" variant="primary" class="mt-4"><i class="ri-add-circle-line"></i>{{ $t('globalTrans.add') }}</b-button>
                                                </b-col>
                                            </b-row>
                                            <hr>
                                            <b-row class="mt-4">
                                                <b-col>
                                                    <b-overlay :show="unitLoad">
                                                    <table class="table table-bordered">
                                                        <tr class="bg-light">
                                                            <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                                            <th scope="col">{{ $t('retailerManagement.product_name') }}</th>
                                                            <th scope="col">{{ $t('retailerManagement.unit') }}</th>
                                                            <th scope="col">{{ $t('retailerManagement.product_quantity') }}</th>
                                                            <th scope="col">{{ $t('sales_distribution_admin.unit_price') }}</th>
                                                            <th scope="col">{{ $t('sales_distribution_admin.total_price') }}</th>
                                                            <th scope="col">{{ $t('globalTrans.action') }}</th>
                                                        </tr>
                                                        <tr v-for="(item, index) in dataArray.details" :key="index">
                                                            <td>{{ $n(index + 1) }}</td>
                                                            <!-- <td>{{ item.product_id }}</td> -->
                                                            <td>{{ productNameByid(item.product_id) }}</td>
                                                            <td>{{ item.unit }}</td>
                                                            <td>{{ item.quantity }}</td>
                                                            <td>{{ item.unit_price }}</td>
                                                            <td>{{ item.total_price }}</td>
                                                            <td>
                                                                <button @click="deleteItem(index)" class="btn btn-danger btn-xs"><i class="fa fa-trash"></i></button>
                                                            </td>
                                                        </tr>
                                                        <b-tr>
                                                            <b-td colspan="5">
                                                            <p class="text-right">Grand Total</p>
                                                            </b-td>
                                                            <b-td class="text-right">
                                                                {{getTotalSum()}}
                                                            </b-td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-td colspan="5">
                                                            <p class="text-right">
                                                                <template>
                                                                    {{ $t('externalUser.production.discount')}}
                                                                </template></p>
                                                            </b-td>
                                                            <td class="text-right">
                                                                <b-form-group>
                                                                    <b-form-input
                                                                    type="number"
                                                                    id="discount"
                                                                    v-model="detailsFormData.discount"
                                                                    ></b-form-input>
                                                                </b-form-group>
                                                            </td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-td colspan="5">
                                                            <p class="text-right">
                                                                {{ $t('externalUser.production.discount_amount')}}
                                                            </p>
                                                            </b-td>
                                                            <td>
                                                                <b-form-group>
                                                                    <b-form-input
                                                                    type="number"
                                                                    id="discount"
                                                                    v-model="detailsFormData.discount_amount"
                                                                    ></b-form-input>
                                                                </b-form-group>
                                                            </td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-td colspan="5">
                                                            <p class="text-right">
                                                                {{ $t('externalUser.production.after_discount')}}
                                                            </p>
                                                            </b-td>
                                                            <td>
                                                                <b-form-group>
                                                                    <b-form-input
                                                                    type="number"
                                                                    id="discount"
                                                                    v-model="detailsFormData.after_discount_amount"
                                                                    ></b-form-input>
                                                                </b-form-group>
                                                            </td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-td colspan="5">
                                                            <p class="text-right">{{ $t('externalUser.production.vat')}}</p>
                                                            </b-td>
                                                            <td>
                                                                <b-form-group>
                                                                    <b-form-input
                                                                    type="number"
                                                                    id="discount"
                                                                    v-model="detailsFormData.vat_amount"
                                                                    ></b-form-input>
                                                                </b-form-group>
                                                            </td>
                                                        </b-tr>
                                                        <b-tr>
                                                            <b-td colspan="5">
                                                            <p class="text-right">{{ $t('externalUser.production.total_paid_amount')}}</p>
                                                            </b-td>
                                                            <td>
                                                                <b-form-group>
                                                                    <b-form-input
                                                                    type="number"
                                                                    id="discount"
                                                                    v-model="detailsFormData.total_paid_amount"
                                                                    ></b-form-input>
                                                                </b-form-group>
                                                            </td>
                                                        </b-tr>
                                                    </table>
                                                    </b-overlay>
                                                </b-col>
                                            </b-row>
                                            <hr>
                                            <b-row>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Delivery Date" vid='delivery_date' rules="required">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="4"
                                                            label-for="delivery_date"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                            {{ $t('retailerManagement.delivery_date')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-input
                                                            placeholder="Select Date"
                                                            id="delivery_date"
                                                            v-model="dataArray.forward.delivery_date"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-input>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12"></b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Comment (En)" vid='comment_en'>
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="comment_en"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                            {{ $t('production_store.comment_en')}}
                                                            </template>
                                                            <b-textarea
                                                            id="note"
                                                            v-model="dataArray.forward.comment_en"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-textarea>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Comment (Bn)" vid='comment_bn'>
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="12"
                                                            label-for="comment_bn"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                            {{ $t('production_store.comment_bn')}}
                                                            </template>
                                                            <b-textarea
                                                            id="comment_bn"
                                                            v-model="dataArray.forward.comment_bn"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-textarea>
                                                            <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                            </b-row>
                                            <div class="row">
                                                <div class="col text-right">
                                                    <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                                    &nbsp;
                                                    <b-button @click="cancel()" variant="danger" class="mr-1">{{ $t('globalTrans.cancel') }}</b-button>
                                                </div>
                                            </div>
                                        </b-form>
                                    </ValidationObserver>
                                </b-col>
                            </b-row>
                            <b-row v-if="view === true">
                                <div class="mt-4 col-lg-12 col-sm-12 col-md-12">
                                    <b-col>
                                        <b-overlay :show="unitLoad">
                                            <table class="table table-bordered">
                                                <tr class="bg-light">
                                                    <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                                    <th scope="col">{{ $t('retailerManagement.product_name') }}</th>
                                                    <th scope="col">{{ $t('retailerManagement.unit') }}</th>
                                                    <th scope="col">{{ $t('retailerManagement.product_quantity') }}</th>
                                                    <th scope="col">{{ $t('globalTrans.action') }}</th>
                                                </tr>
                                                <tr v-for="(item, index) in dataArray.details" :key="index">
                                                   <td>{{ $n(index + 1) }}</td>
                                                    <td>{{ productNameByid(item.product_id) }}</td>
                                                    <td>{{ item.unit }}</td>
                                                    <td>{{ item.quantity }}</td>
                                                </tr>
                                            </table>
                                        </b-overlay>
                                    </b-col>
                                </div>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
// import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
// import RestApi, { authServiceBaseUrl, productionServiceBaseUrl } from '@/config/api_config'
// import { materialRequisitionStoreApi, materialRequisitionUpdateApi, getRequisitionIdApi, rawMaterialInfoById, userListApi } from '../../api/routes'
import flatpickr from 'flatpickr'
// import moment from 'moment'

export default {
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data () {
        return {
            saveBtnName: this.mat_id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            detailsFormData: {
                category_id: 0,
                sub_category_id: 0,
                product_id: 0,
                unit: 3,
                quantity: 0,
                unit_price: 5,
                total_price: 0,
                grand_total: 0,
                discount: 0,
                discount_amount: 0,
                after_discount_amount: 0,
                vat_amount: 0,
                total_paid_amount: 0,
                delivery_date: '',
                remark_en: '',
                remark_bn: '',
                agent_type: ''
            },
            dataArray: {
                details: [],
                forward: {
                    delivery_date: '',
                    comment_en: '',
                    comment_bn: ''
                }
            },
            options: [
                    { item: 1, name: this.$i18n.locale === 'bn' ? 'ডিলার' : 'Dealer' },
                    { item: 2, name: this.$i18n.locale === 'bn' ? 'খুচরা বিক্রেতা' : 'Retailer' },
                    { item: 3, name: this.$i18n.locale === 'bn' ? 'বিক্রয় কেন্দ্র' : 'Sales Center' }
            ],
            mat_id: 0,
            sl: 0,
            view: false,
            addForward: true,
            subCategoryLists: [],
            productList: [],
            productUnitList: [],
            designationList: [],
            userList: [],
            loading: false,
            unitLoad: false,
            total_qty: ''
        }
    },
    watch: {
        'detailsFormData.quantity': function (newVal, oldVal) {
                this.detailsFormData.total_price = this.getTotalPrice()
        },
        'detailsFormData.discount': function (newVal, oldVal) {
                this.detailsFormData.discount_amount = this.detailsFormData.grand_total * (newVal / 100)
                this.detailsFormData.after_discount_amount = this.detailsFormData.grand_total - this.detailsFormData.discount_amount
                this.detailsFormData.total_paid_amount = this.detailsFormData.after_discount_amount
        },
        'detailsFormData.vat_amount': function (newVal, oldVal) {
            if (newVal !== '') {
              this.detailsFormData.total_paid_amount = (this.detailsFormData.grand_total + parseInt(newVal)) - this.detailsFormData.discount_amount
            } else {
              this.detailsFormData.total_paid_amount = this.detailsFormData.grand_total - this.detailsFormData.discount_amount
            }
        }
    },
    computed: {
        categoryList: function () {
            return this.$store.state.ProductionService.commonObj.productCategoryList.filter(item => item.status === 1)
        },
        subCategoryList: function () {
            return this.$store.state.ProductionService.commonObj.productSubCategoryList.filter(item => item.status === 1)
        },
        productNameList: function () {
            return this.$store.state.ProductionService.commonObj.productList.filter(item => item.status === 1)
        },
        orgList: function () {
            return this.$store.state.orgList.filter(item => item.status === 0)
        },
        currentLocale: function () {
            return this.$i18n.locale
        },
        ...mapGetters({
            productCommonObj: 'ProductionService/commonObj'
        })
    },
    mounted () {
            flatpickr('#delivery_date', {})
            // this.getRequisitionId()
    },
    created () {
        if (this.$route.query.view) {
            this.view = true
            this.addForward = false
        }
        if (this.$route.query.id) {
            this.mat_id = this.$route.query.id
            this.getRequisitionInfoData(this.$route.query.id)
            this.addForward = false
        }
    },
    methods: {
        getTotalSum () {
            const totalSum = this.dataArray.details.reduce((acc, item) => acc + item.total_price, 0)
            this.detailsFormData.grand_total = totalSum
            return totalSum
        },
        getTotalPrice (val) {
            return this.detailsFormData.unit_price * this.detailsFormData.quantity
        },
        deleteItem (index) {
            this.dataArray.details.splice(index, 1)
        },
        addItem () {
            if (this.detailsFormData.product_id !== 0 && this.detailsFormData.unit !== 0 && this.detailsFormData.quantity !== 0) {
                const existsProduct = this.dataArray.details.some(data => data.product_id === this.detailsFormData.product_id)
                const existsUnit = this.dataArray.details.some(data => data.unit === this.detailsFormData.unit)
                const existsQuanaity = this.dataArray.details.some(data => data.quantity === this.detailsFormData.quantity)
                if (existsProduct && existsUnit && existsQuanaity) {
                    this.dataArray.details.forEach((result, index) => {
                        if (result.product_id === this.detailsFormData.product_id && result.unit === this.detailsFormData.unit && result.quantity === this.detailsFormData.quantity) {
                            this.detailsFormData = {
                                product_id: 0,
                                category_id: 0,
                                sub_category_id: 0,
                                unit: 4,
                                unit_price: 40,
                                quantity: ''
                            }
                        }
                    })
                } else {
                    this.dataArray.details.push(this.detailsFormData)
                    this.detailsFormData = {
                       product_id: 0,
                        category_id: 0,
                        sub_category_id: 0,
                        unit: 4,
                        unit_price: 40,
                        quantity: ''
                    }
                }
            }
        },
        async saveData () {
            // this.$store.dispatch('mutateCommonProperties', { loading: true })
            // let result = null
            // const loadingState = { loading: false, listReload: false }
            // if (this.mat_id) {
            //     result = await RestApi.putData(productionServiceBaseUrl, `${materialRequisitionUpdateApi}/${this.mat_id}`, this.dataArray)
            // } else {
            //     result = await RestApi.postData(productionServiceBaseUrl, materialRequisitionStoreApi, this.dataArray)
            // }

            // loadingState.listReload = true
            // this.$store.dispatch('mutateCommonProperties', loadingState)

            // if (result.success) {
            //     this.$store.commit('ProductionService/mutateCommonObj', { hasDropdownLoaded: false })
            //     this.$toast.success({
            //         title: this.$t('globalTrans.success'),
            //         message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
            //         color: '#D6E09B'
            //     })
            //     this.$router.push({ path: '/production-service/store-management/raw-material-requisition-list' })
            // } else {
            //     this.$refs.form.setErrors(result.errors)
            // }
        },
        productNameByid (id) {
            const product = this.$store.state.ProductionService.commonObj.productList.find(product => product.value === id)
            if (this.$i18n.locale === 'bn') {
                return product.text_bn
            } else {
               return product.text_en
            }
        },
        productSubCategoryById (id) {
            const subCategory = this.productCommonObj.productSubCategoryList.find(subCategory => subCategory.value === id)
            if (this.$i18n.locale === 'bn') {
                return subCategory.text_bn
            } else {
               return subCategory.text_en
            }
        },
        yearNameById (id) {
            const product = this.fiscalYearList.find(product => product.value === id)
            if (this.$i18n.locale === 'bn') {
                return product.text
            } else {
               return product.text
            }
        },
        monthNameById (id) {
            const unit = this.MonthList.find(unit => unit.value === id)
            if (this.$i18n.locale === 'bn') {
                return unit.text
            } else {
               return unit.text
            }
        },
        padString (serial) {
            var str = '' + serial
            var pad = '0000'
            var ans = pad.substring(0, pad.length - str.length) + str
            return ans
        }
    }
}
</script>
